<template>
	<transition name="modal">
		<div :class="modalState">
	    <div class="modal__mask">
	      <div class="modal__wrapper">
	        <div class="modal__container">

	          <div class="modal__header">
	            {{ modalTitle }}
	          </div>

	          <div v-if="isOpen()" class="modal__body">
	          	<component :is="currentView"></component>
	          </div>

	          <div class="modal__control">
	            <button class="modal__close-button" @click="closeModal">&times;</button>
	          </div>
	        </div>
	      </div>
	    </div>
    </div>
  </transition>
</template>

<script>

/**
 * Modal JSFiddle
 * https://jsfiddle.net/yyx990803/mwLbw11k/?utm_source=website&utm_medium=embed&utm_campaign=mwLbw11k
 *
 * Repeater JSFiddle
 * https://jsfiddle.net/cr8vfgrz/10/
 */

import PrintForm from './PrintForm/PrintForm.vue'
import Disclaimers from './Disclaimers.vue'

export default {


	components: {



	}, 

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

  	closeModal() {

  		this.$store.dispatch('closeModal');

  	},

    isOpen() {

      var modal = this.$store.getters.modalVars;

      return modal.state;

    }

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

  	modalState() {

  		var c = 'modal',
  		    modal_state = this.$store.getters['modalState'];

  		if (modal_state) {

  			c += ' js-active';

  		}

  		return c;
  		// return this.$store.getters[this.field];

  	},

  	currentView() {

      var c = this.$store.getters.modalComponent
  		return this.views[c];

  	},

		modalTitle() {

			var vars = this.$store.getters.modalVars;

			return vars.title;

		}  	  	

  },

  props : [
  	
  ],

  data() {

    return {

    	views: {

				'printForm' : PrintForm,
        'disclaimers' : Disclaimers,

    	},

    }

  }

}

</script>

<style lang="scss">

.modal {

	opacity: 0;
	visibility: hidden;
  position: relative;
  z-index: 9998;  

	transition: transform .3s ease, opacity .3s ease, visibility .3s ease;


  &.js-active {

  	opacity: 1;
  	visibility: visible;

    .modal__container {

      transform: scale(1);

    }

  }

  h2 {

    margin-bottom: 1.25em;

    .icon {

      display: inline-block;
      align-items: normal;
      justify-content: normal;

      width: 1.5rem;
      height: 1.5rem;
      margin-right: .8rem;
      transform: translate3d(0, -1px, 0);

    }

    .icon__svg {

      fill: #999;
      stroke: #999;

    }

  }

  h3 {

    margin-top: 1.5rem;
    margin-bottom: .85rem;
    color: #182938;

  }

  p {

    font-size: .9rem;
    margin-bottom: 1rem;

  }  

}

.modal__mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;

}

.modal__wrapper {

	display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

}

.modal__container {
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .5s ease;
  font-family: Helvetica, Arial, sans-serif;

  position: relative;

  width: 90vw;
  height: 90vh;

  transform: scale(0);

}

.modal__header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal__body {
  margin: 20px 0;
  height: 100%;
}

.modal__close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;

  appearance: none;
  background: none;
  border: 0;

  text-align: center;
  width: 1.8rem;
  height: 1.8rem;

  border-radius: 2px;

  &:hover,
  &:focus,
  &:active {

    background: #eee;

  }

}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal__enter {
  opacity: 0;
}

.modal__leave-active {
  opacity: 0;
}

.modal__enter .modal__container,
.modal__leave-active .modal__container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


</style>




// WEBPACK FOOTER //
// Modal.vue?3ef9d753